import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MidTermAdjustmentRatingResponse, MtaResponse, PaymentProvider2 } from '@acorn-portal/shared/src/services/api';

export interface IPaymentOptionsRouteState {
	isReturnPremium: boolean;
	isCardPaymentAvailable: boolean;
	isFinanceAvailable: boolean;
}

export interface IMidTermAdjustmentRatingResponseState extends MidTermAdjustmentRatingResponse {
	isValid: boolean;
	isReturnPremium: boolean;
	isCardPaymentAvailable: boolean;
	isFinanceAvailable: boolean;
}

const INITIAL_STATE: IMidTermAdjustmentRatingResponseState = {
	isValid: false,
	optionId: '',
	underwritingOutcomeResponseId: '',
	transactionId: '',
	paymentOptions: [],
	mtaResponse: MtaResponse.NotTakenUp,
	hasDeclined: false,
	isReturnPremium: false,
	isCardPaymentAvailable: false,
	isFinanceAvailable: false,
	coverDetails: {
		fee: 0,
		voluntaryExcess: 0,
		compulsoryExcess: 0,
		endorsements: undefined,
		driverExcesses: [],
	},
	existingCardPaymentMethods: [],
	drivers: [],
	paymentProvider: PaymentProvider2.BRAINTREE,
};

export const midTermAdjustmentRatingResponseSlice = createSlice({
	name: 'midTermAdjustmentRatingResponse',
	initialState: INITIAL_STATE,
	reducers: {
		setMidTermAdjustmentRatingResponse: (
			state,
			action: PayloadAction<Partial<IMidTermAdjustmentRatingResponseState>>,
		) => ({
			...state,
			...action.payload,
		}),
		setRoutingOptions: (state, action: PayloadAction<Partial<IPaymentOptionsRouteState>>) => ({
			...state,
			...action.payload,
		}),
		clearMidTermAdjustmentResponseDetails: () => ({
			...INITIAL_STATE,
		}),
	},
});

export const { setMidTermAdjustmentRatingResponse, setRoutingOptions, clearMidTermAdjustmentResponseDetails } =
	midTermAdjustmentRatingResponseSlice.actions;
export default midTermAdjustmentRatingResponseSlice.reducer;
